import { Skeleton } from '@grupoboticario/barril-del-chavo'
import { Flex, useIsMobile } from '@grupoboticario/flora-react'
import { PropsWithChildren } from 'react'

const ShopSample = () => (
  <Flex
    css={{ width: '158px', background: 'white', padding: '10px', borderRadius: '4px' }}
    direction="column"
    justify="space-between"
  >
    <Skeleton css={{ width: '100%', height: '80px' }} />
    <Skeleton css={{ width: '100%', height: '68px' }} />
    <Skeleton css={{ width: '100%', height: '16px' }} />
    <Skeleton css={{ width: '100%', height: '40px' }} />
    <Skeleton css={{ width: '100%', height: '32px' }} />
  </Flex>
)

const Wrapper = ({ children }: PropsWithChildren<{}>) => (
  <Flex
    css={{ background: '#f5f5f5', height: '316px', padding: '10px' }}
    justify="space-around"
    role="slider"
    data-testid="shop-window-skeleton"
  >
    {children}
  </Flex>
)

export const LoadingSkeleton = () => {
  const isMobile = useIsMobile()

  if (isMobile) {
    return (
      <Wrapper>
        <ShopSample />
        <ShopSample />
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <ShopSample />
      <ShopSample />
      <ShopSample />
      <ShopSample />
    </Wrapper>
  )
}
